module.exports = __webpack_public_path__ + "static/media/Blender-2.d25950d8.webp";